import { useTranslation } from "react-i18next";
import { Panel, PanelHeaderTemplateOptions } from 'primereact/panel';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatarParaMoedaBRL } from "../../../utils";
import NadaConsta from "../../../components/nadaConsta";
import { Card } from "primereact/card";




export default function CreditoPositivo({
  creditoPositivo
}: {
  creditoPositivo: any
}) {
  const { t } = useTranslation();

  const headerTemplatePendencia2 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoPositivo.PEND_REFIN && creditoPositivo.PEND_REFIN.OCORRENCIAS && creditoPositivo.PEND_REFIN.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia2')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia2')}</span>)}</div>;
  }

  const headerTemplatePendencia3 = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {creditoPositivo.PEND_VENCIDAS && creditoPositivo.PEND_VENCIDAS.OCORRENCIAS && creditoPositivo.PEND_VENCIDAS.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia3')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia3')}</span>)}</div>;
  }

  const getResumoProtesto = (data: any) => {
    const resumos: any[] = [];
    if (data && data.OCORRENCIAS && data.OCORRENCIAS.length > 0) {
      resumos.push({
        icon: 'pi pi-chart-line',
        label: 'Quantidade Comarcas',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-gauge',
        label: 'Quantidade Protestos',
        value: 0
      })
      resumos.push({
        icon: 'pi pi-dollar',
        label: 'Valor Total Protestos',
        value: '0'
      })
      let valorTotal = 0.0
      let quantidade = 0;
      const comarcas: any[] = []
      data.OCORRENCIAS.forEach((prot: any) => {
        quantidade++;
        valorTotal = valorTotal + Number(prot.VALOR.replace('.', '').replace(',', '.'))
        if (!comarcas.includes(prot.COMARCA)) {
          comarcas.push(prot.COMARCA)
        }
      });
      resumos[0].value = comarcas.length;
      resumos[1].value = quantidade;
      resumos[2].value = formatarParaMoedaBRL(valorTotal);
    }

    return resumos;
  }

  const headerTemplateProtesto = (data: any) => (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {data && data.OCORRENCIAS && data.OCORRENCIAS.length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('protestos')}</span>)}</div>;
  }

  const renderProtestoSection = (data: any) => {
    if (!data) return null;

    return (
      <Panel headerTemplate={headerTemplateProtesto(data)}>
        {!data.OCORRENCIAS || data.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
          <div className="flex-consulta  flex-wrap gap-3">
            {getResumoProtesto(data).map((item: any, index: number) => (

              <Card className='flex-1' style={{ backgroundColor: '#2e2eb8' }} key={index}>
                <div className="flex-consulta  justify-content-between gap-5">
                  <div className="flex-consulta  flex-column gap-1">
                    <span style={{ color: 'white' }} className=" text-sm">{item.label}</span>
                    <span style={{ color: 'white' }} className="font-bold text-lg">{item.value}</span>
                  </div>
                  <span className="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" style={{ backgroundColor: 'white', color: '#183462' }}>
                    <i className={item.icon} />
                  </span>
                </div>
              </Card>

            ))}
          </div>
          <br></br>
          <DataTable size="small" value={data.OCORRENCIAS} tableStyle={{ minWidth: '50rem' }}>
            <Column field="DATA" header={t('data')}></Column>
            <Column field="CARTORIO" header={t('cartorio')}></Column>
            <Column field="COMARCA" header={t('cidade')}></Column>
            <Column field="UF" header={t('uf')}></Column>
            <Column body={(item) => formatarParaMoedaBRL(Number(item.VALOR.replaceAll('.', '').replace(',', '.')))} field="VALOR" header={t('valor')}></Column>
          </DataTable>
        </>)}
      </Panel>
    )
  }

  const getOcorrenciasPorProvedor = (provedor: string) => {
    if (creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.length > 0) {
      return creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.filter((ocorrencia: any) => ocorrencia.INFORMANTE === provedor);
    }
    return [];
  }

  const getValorTotalPendencias = () => {
    if (creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.length > 0) {
      let valorTotal = 0;
      creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.forEach((ocorrencia: any) => {
        valorTotal += Number(ocorrencia.VALOR.replaceAll('.', '').replace(',', '.'));
      });
      return formatarParaMoedaBRL(valorTotal);
    }
    return formatarParaMoedaBRL(0);
  }


  const headerTemplatePendencia = (provedor: string) => (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return <div className={className}> {getOcorrenciasPorProvedor(provedor).length > 0 ? (<div><span style={{ color: '#C70039' }} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia') + ' ' + provedor}</span></div>) : (<span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', color: 'black' }}>{t('pendencia') + ' ' + provedor}</span>)}</div>;
  }


  return (
    <div>
      {creditoPositivo.mensagemErro ? (<p>{creditoPositivo.mensagemErro}</p>) :
        (<div>
          <br></br>
          {creditoPositivo.PROTESTOS && renderProtestoSection(creditoPositivo.PROTESTOS)}
          <br></br>
          {creditoPositivo.PROTESTO_SINTETICO && renderProtestoSection(creditoPositivo.PROTESTO_SINTETICO)}
          <br></br>
          {creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.PROVEDORES && (
            <Panel header="Pendências Financeiras">
              {creditoPositivo.PEND_FINANCEIRAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS && creditoPositivo.PEND_FINANCEIRAS.OCORRENCIAS.length > 0 && (
                <div style={{ paddingBottom: '2rem', paddingLeft: '5rem' }}><span style={{ padding: '2rem' }}><b>VALOR TOTAL:</b> {getValorTotalPendencias()} </span><span style={{ padding: '2rem' }}><b>QUANTIDADE DE PENDÊNCIAS HOJE:</b> {creditoPositivo.PEND_FINANCEIRAS.QUANTIDADE_OCORRENCIA} </span><span style={{ padding: '2rem' }}><b>ÚLTIMA OCORRÊNCIA:</b> {creditoPositivo.PEND_FINANCEIRAS.ULTIMO_VENCIMENTO} </span></div>
              )}
              {creditoPositivo.PEND_FINANCEIRAS.PROVEDORES.map((provedor: any) => (
                <div>
                  <Panel headerTemplate={headerTemplatePendencia(provedor.PROVEDOR)}>
                    {getOcorrenciasPorProvedor(provedor.PROVEDOR).length === 0 ? (<NadaConsta />) : (<>
                      <DataTable size="small" value={getOcorrenciasPorProvedor(provedor.PROVEDOR)} tableStyle={{ minWidth: '50rem' }}>
                        <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                        <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                        <Column field="CONTRATO" header={t('contrato')}></Column>
                        <Column field="ORIGEM" header={t('origem')}></Column>
                        <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                        <Column field="CREDOR" header={t('informante')}></Column>
                        <Column body={(item) => formatarParaMoedaBRL(Number(item.VALOR.replace(',', '.')))} field="VALOR" header={t('valor')}></Column>
                      </DataTable>
                    </>)}
                  </Panel>
                  <br></br>
                </div>
              ))}
            </Panel>
          )}
          <br></br>
          <Panel headerTemplate={headerTemplatePendencia2}>
            {!creditoPositivo.PEND_REFIN || !creditoPositivo.PEND_REFIN.OCORRENCIAS || creditoPositivo.PEND_REFIN.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
              <DataTable size="small" value={creditoPositivo.PEND_REFIN.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                <Column field="CONTRATO" header={t('contrato')}></Column>
                <Column field="ORIGEM" header={t('origem')}></Column>
                <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                <Column field="CREDOR" header={t('informante')}></Column>
                <Column field="VALOR" header={t('valor')}></Column>
              </DataTable>
            </>)}
          </Panel>
          <br></br>
          <Panel headerTemplate={headerTemplatePendencia3}>
            {!creditoPositivo.PEND_VENCIDAS || !creditoPositivo.PEND_VENCIDAS.OCORRENCIAS || creditoPositivo.PEND_VENCIDAS.OCORRENCIAS.length === 0 ? (<NadaConsta />) : (<>
              <DataTable size="small" value={creditoPositivo.PEND_VENCIDAS.OCORRENCIAS} responsiveLayout="stack" breakpoint="960px">
                <Column field="DATA_INCLUSAO" header={t('data')}></Column>
                <Column field="DATA_VENCIMENTO" header={t('vencimento')}></Column>
                <Column field="CONTRATO" header={t('contrato')}></Column>
                <Column field="ORIGEM" header={t('origem')}></Column>
                <Column field="TIPO_DEVEDOR" header={t('tipo')}></Column>
                <Column field="CREDOR" header={t('informante')}></Column>
                <Column field="VALOR" header={t('valor')}></Column>
              </DataTable>
            </>)}
          </Panel>

          <br></br>

        </div>)}
    </div>
  )
}